import { NOBU_THEME_PATH } from "../constants";
import FloatingButton from "../objects/floating-button";
import { awaitElement, createElement, useElement } from "../utils/element-handlers.utils";
import { themeImage } from "../utils/theme-assets.utils";

type FloatingButtonRaw = HTMLElement | FloatingButton | ((createdFloatingButton: FloatingButton) => FloatingButton) | null;

const validButtonTagNames = [
    'BUTTON', 'SPAN', 'DIV', 'A'
];

const pagesToFitOnTop = [
    'HomeHolder',
    'HomeReservePage',
    'HomeSliderPage',
    'RestaurantHomePage',
    'RestaurantPage',
    'RestaurantCareersPage',
    'RestaurantContactPage',
    'DeliveryRestaurantMenus',
    'RestaurantMenus',
    'RestaurantPrivateEventsPage',
    'RestaurantReservePage',
    'RestaurantReservationsPage'
];

declare var UserWay: {
  widgetToggle: () => void;
};

function FloatingButtonsComponent(elementsToBeFloatingButtons: FloatingButtonRaw[]) {
    const floatingButtonInstances: FloatingButton[] = elementsToBeFloatingButtons
        .map(function (elementToBeFloatingButton) {
            if (elementToBeFloatingButton instanceof HTMLElement) {
                if (validButtonTagNames.indexOf(elementToBeFloatingButton.tagName) !== -1) {
                    return new FloatingButton(elementToBeFloatingButton, false, '');
                }

                var errorMessage = (
                    'initFloatingButtons(): Invalid HTMLElement to be a FloatingButton: "'
                    + elementToBeFloatingButton.tagName
                    + '". This content will be not displayed. Please use one of these valid tags: ['
                    + validButtonTagNames.join(', ')
                    + ']'
                );

                throw new Error(errorMessage);
            }
            else if (elementToBeFloatingButton instanceof FloatingButton) {
                if (!elementToBeFloatingButton.getButtonElement()) {
                    throw new Error('Cannot init a FloatingButton without a buttonElement');
                }

                return elementToBeFloatingButton;
            }
            else if (typeof elementToBeFloatingButton === 'function') {
                return elementToBeFloatingButton(new FloatingButton(true, false, ''));
            }
            
            return null;
        })
        .filter(function (floatingButtonInstanceOrNull) {
            return floatingButtonInstanceOrNull !== null;
        }) as  FloatingButton[];

    const floatingButtonsWrapper = createElement(
        'div',
        {
            className: 'n-floating-buttons n-floating-buttons-hidden'
        },
        floatingButtonInstances.map(function (floatingButtonInstance) {
            return useElement(floatingButtonInstance.getButtonElement()!, 'n-floating-button');
        })
    );

    document.body.append(floatingButtonsWrapper);

    setTimeout(function () {
        floatingButtonsWrapper.classList.remove('n-floating-buttons-hidden');
    }, 500);

    const pageClass = document.body.getAttribute('id');
    if (pageClass && (pagesToFitOnTop.indexOf(pageClass) !== -1)) {
        toggleFit();

        window.addEventListener('scroll', toggleFit);
        window.addEventListener('resize', toggleFit);

        function toggleFit() {
            if ((window.scrollY === 0) && (window.innerWidth >= 768)) {
                floatingButtonsWrapper.classList.add('n-floating-button-fit');
            }
            else {
                floatingButtonsWrapper.classList.remove('n-floating-button-fit');
            }
        }
    }
}

export default function initFloatingButtonsComponent() {
    FloatingButtonsComponent([
        instaplayFloatingButton(),
        // yextSearchFloatingButtonAndAPI(),
        userWayFloatingButton(),
        goToTopFloatingButton()
    ])
}

function instaplayFloatingButton() {
    // if (!window.nobuInstaplay) return null;
    if (!window.hasOwnProperty('nobuInstaplay')) return null;
    
    const floatingButtonInstance = new FloatingButton(false, false, '');
    let isReady = false;
    let originalInstaplayButton: HTMLElement | null = null;
    const instaplayFloatingButton = createElement('button', 'n-floating-button-hidden-',
        createElement('img', {
            className: 'n-floating-button-icon',
            src: themeImage('icon-instaplay.svg')
        }),
        {
            click: function (event) {
                event.preventDefault();
                event.stopPropagation();

                if (isReady) {
                    toggleInstaplayWidget();
                }
                else if (!floatingButtonInstance.isBusy()) {
                    floatingButtonInstance.setBusy();

                    initInstaplayUIChecking(function () {
                        floatingButtonInstance.unsetBusy();
                        toggleInstaplayWidget();
                    });
                }
            }
        }
    );

    floatingButtonInstance.setButtonElement(instaplayFloatingButton);
    initInstaplayUIChecking();

    function initInstaplayUIChecking(onFinishCallback?: (isReady: boolean) => void) {
        awaitElement('div#iw-bubble-container', 30, 500)
            .then(function (instaplayWrapperElement) {
                originalInstaplayButton = instaplayWrapperElement.querySelector('div.iw-bubble-btn');
    
                if (originalInstaplayButton) {
                    originalInstaplayButton.style.display = 'none !important';
                }
    
                instaplayWrapperElement.classList.add('n-force-show-instaplay-wrapper');
                instaplayFloatingButton.appendChild(instaplayWrapperElement);
                floatingButtonInstance.unsetHidden();
                isReady = true;

                if (onFinishCallback) {
                    onFinishCallback(isReady);
                }

            }, function () {
                floatingButtonInstance.unsetHidden();
                isReady = false;
                // console.log('not ready')

                if (onFinishCallback) {
                    onFinishCallback(isReady);
                }
            });
    }

    function toggleInstaplayWidget() {
        if (originalInstaplayButton) {
            originalInstaplayButton.click();
        }
    }
    
    return floatingButtonInstance;
}

// function yextSearchFloatingButtonAndAPI() {
//     const floatingButtonInstance = new FloatingButton(true, true, themeImage('icon-yext.svg'), toggleYextUI);
//     const floatingButtonElement = floatingButtonInstance.getButtonElement()!;
//     const yextSearchUIWrapper = createElement('div', 'n-yext-search-ui', 
//         createElement('button', 'n-yext-search-ui-close-button',
//             createElement('img', {
//                 src: themeImage('icon-close.svg'),
//                 alt: 'Close',
//                 title: 'Close'
//             }), {
//                 click: function (event) {
//                     event.preventDefault();
//                     event.stopPropagation();
//                     closeYextUI();
//                 }
//             }
//         )
//     );
    
//     document.body.append(yextSearchUIWrapper);

//     fitOnTopYextUIFeature();
//     initYextIntegration();

//     function initYextIntegration() {
//         floatingButtonInstance.setHidden();

//         window.YxtAnswersOverlaySettings = {
//             domain: "https://answers-embed.noburestaurants.com.pagescdn.com/",
//             button: {
//                 color: {
//                     background: '#886E42'
//                 }
//             },
//             panel: {
//                 header: "Have a question?",
//                 subtitle: "Find Nobu locations, menus, and FAQs!",
//                 color: {
//                     background: '#86754D',
//                     textforeground: '#FFFFFF'
//                 }
//             },
//             prompts: [
//                 { text: "Restaurants near me", },
//                 { text: "Dinner menu", },
//                 { text: "COVID-19 policies", },
//                 { text: "Are you open for dining?", },
//             ]
//         };
//         window._yextOverlayWrapper = yextSearchUIWrapper;
//         window._yextButtonFrameWrapper = floatingButtonElement
//             ? createElement('div', 'n-YxtAnswersOverlay-buttonFrame')
//             : null;

//         if (window._yextButtonFrameWrapper) {
//             floatingButtonElement.prepend(window._yextButtonFrameWrapper);
//         }

//         const headElement = document.querySelector('head')!;
//         const scriptElement = document.createElement('script');

//         scriptElement.type = 'text/javascript';
//         scriptElement.async = true;
//         scriptElement.src = NOBU_THEME_PATH + '/javascript/yext-overlay.custom.js';
//         headElement.appendChild(scriptElement);

//         awaitElement('#YxtAnswersOverlay', 10, 500)
//             .then(onFoundYxtAnswersOverlayElement, onNotFoundYxtAnswersOverlayElement);

//         function onFoundYxtAnswersOverlayElement() {
//             floatingButtonInstance.unsetHidden();
//         }

//         function onNotFoundYxtAnswersOverlayElement() {
//             floatingButtonInstance.unsetHidden();
//         }
//     }

//     function toggleYextUI() {
//         if (yextSearchUIWrapper.classList.contains('n-yext-search-ui-active')) {
//             closeYextUI();
//         }
//         else {
//             openYextUI();
//         }
//     }

//     function openYextUI() {
//         floatingButtonInstance.setActive();
//         yextSearchUIWrapper.classList.add('n-yext-search-ui-active');
//         document.body.classList.add('n-yext-search-ui-is-active');

//         setTimeout(function () {
//             yextSearchUIWrapper.classList.add('n-yext-search-ui-ready');
//         }, 0);
//     }

//     function closeYextUI() {
//         floatingButtonInstance.unsetActive();
//         yextSearchUIWrapper.classList.remove('n-yext-search-ui-ready');
//         document.body.classList.remove('n-yext-search-ui-is-active');

//         setTimeout(function () {
//             yextSearchUIWrapper.classList.remove('n-yext-search-ui-active');
//         }, 300);
//     }

//     function fitOnTopYextUIFeature() {
//         var pagesToFitOnTopForYextSearch = [
//             'HomeHolder',
//             'HomeReservePage',
//             'HomeSliderPage',
//             'RestaurantHomePage',
//             'RestaurantPage',
//             'RestaurantCareersPage',
//             'RestaurantContactPage',
//             'DeliveryRestaurantMenus',
//             'RestaurantMenus',
//             'RestaurantPrivateEventsPage',
//             'RestaurantReservePage',
//             'RestaurantReservationsPage'
//         ];
//         var fitOnTop = pagesToFitOnTopForYextSearch.indexOf(document.body.getAttribute('id')!) !== -1;

//         if (fitOnTop) {
//             window.addEventListener('scroll', fitYextSearchUIWrapper);
//             fitYextSearchUIWrapper();
//             function fitYextSearchUIWrapper() {
//                 if (window.scrollY === 0) {
//                     yextSearchUIWrapper.classList.add('n-yext-search-ui-fit');
//                 }
//                 else {
//                     yextSearchUIWrapper.classList.remove('n-yext-search-ui-fit');
//                 }
//             }
//         }
//     }

//     return floatingButtonInstance;
// }

function userWayFloatingButton() {
    const floatingButtonInstance = new FloatingButton(false, false, '');
    const userWayFloatingButton = createElement('button', 'n-floating-button-hidden',
        createElement('img', {
            className: 'n-floating-button-icon',
            src: themeImage('icon-userway.svg')
        }),
        {
            click: function (event) {
                event.preventDefault();
                event.stopPropagation();
                openUserWayUI();
            }
        }
    );

    let userWayUIElement: HTMLElement | null = null;
    let userWayUIButton: HTMLElement | null = null;
    let userWayUILoading: boolean = false;
    let userWayUILoaded: boolean = false;

    floatingButtonInstance.setButtonElement(userWayFloatingButton);

    awaitElement('div.uwy.userway_p3', 15, 1000).then(function (element) {
        userWayUIElement = element;
        userWayUIButton = userWayUIElement.querySelector('#userwayAccessibilityIcon');
        floatingButtonInstance.unsetHidden();
    });

    function openUserWayUI() {
        if (userWayUILoading) {
            // alert("is loading");
            return;
        }

        if (userWayUIElement && userWayUIButton) {
            //userWayUIButton.click();
	    UserWay.widgetToggle();
            if (!userWayUILoaded) {
                userWayUILoading = true;
                floatingButtonInstance.setBusy();

                awaitElement('div.uwy.userway_p3.uon', 15, 500).then(function () {
                    userWayUILoading = false;
                    userWayUILoaded = true;
                    floatingButtonInstance.unsetBusy();
                    // alert("start");
                }, function () {
                    floatingButtonInstance.unsetBusy();
                    // alert("failure");
                });
            }
        }
    }

    return floatingButtonInstance;
}

function goToTopFloatingButton() {
    var floatingButtonInstance = new FloatingButton(false, false, '');
    var goToTopFloatingButton = createElement('button', null, 
        createElement('img', {
            className: 'n-floating-button-icon',
            src: themeImage('icon-go-to-top.svg'),
            style: 'width: 100%; max-width: 100%; max-height: 100%; height: 100%;'
        }), {
        click: function (event) {
            event.preventDefault();
            event.stopPropagation();
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    });

    floatingButtonInstance.setButtonElement(goToTopFloatingButton)

    function toggleGoToTopButton() {
        if (window.scrollY) {
            floatingButtonInstance.unsetHidden();
        }
        else {
            floatingButtonInstance.setHidden();
        }
    }

    toggleGoToTopButton();

    let scrollDetectTimer: ReturnType<typeof setTimeout>;
    window.addEventListener('scroll', function () {
        toggleGoToTopButton();
        floatingButtonInstance.setBusy();

        clearTimeout(scrollDetectTimer);
        scrollDetectTimer = setTimeout(function () {
            floatingButtonInstance.unsetBusy();
        }, 150);
    }, {
        passive: true
    });

    return floatingButtonInstance;
}
